import * as React from 'react';
import ChartMetricInterface from '@app/Interface/Chart/ChartMetricInterface';
import moment from 'moment';

import SCTabulator from '@app/utils/SCTabulator';
import options from '@app/utils/SCTabulatorCommonOptions';

interface ChartMetricsTableProps {
    data: ChartMetricInterface;
}

const ChartMetricsTable: React.FC<ChartMetricsTableProps> = ({data, children}) => {
    // In order to get tabulator to work with moment-timezone
    // we need to add moment to the global namespace.
    // see: https://stackoverflow.com/a/54135475/8038146
    window.moment = moment;

    const tableRef = React.useCallback(node => { return {current: node} }, []);
    const tableRows = [
        {metricFor: 'Producer', low: data.producerLow, high: data.producerHigh, avg: data.producerAverage},
        {metricFor: 'NDA', low: data.ndaLow, high: data.ndaHigh, avg: data.ndaAverage},
    ];

    const tabulatorColumns = [
        { title: '', field: 'metricFor', headerSort: false },
        { title: 'Low', field: 'low', formatter: 'money', formatterParams: {
            precision: 4
        }, headerSort: false },
        { title: 'High', field: 'high', formatter: 'money', formatterParams: {
            precision: 4
        }, headerSort: false },
        { title: 'Avg', field: 'avg', formatter: 'money', formatterParams: {
            precision: 4
        }, headerSort: false },
    ];

    return (
        <SCTabulator
                tableRef={tableRef}
                data={tableRows}
                columns={tabulatorColumns}
                layout="fitColumns"
                options={{
                    ...options('nda-metrics-table-sc', false, false)
                }}
            />
    );
}

export default ChartMetricsTable;